import {useAppContext} from '@navbar-registry';
import {defineNuxtPlugin, useAuth} from '#imports';

export default defineNuxtPlugin({
    name: 'load-navbar-context',
    parallel: true,
    dependsOn: ['fetch-auth'],
    async setup(nuxtApp) {
        const auth = useAuth();

        if (!auth.loggedIn) {
            return;
        }

        const {loadAppContext, loadNotifications} = useAppContext();

        // Server-side or client-side for CSR app
        if (import.meta.server || (import.meta.client && !nuxtApp.payload.serverRendered)) {
            await loadAppContext();
        }
        // Client-side for SSR app
        if (import.meta.client && nuxtApp.payload.serverRendered) {
            await loadNotifications();
        }
    },
});
